var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlwaysFailing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_505_40168)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58709 0.274588C5.7629 0.098772 6.00136 0 6.25 0H13.75C13.9986 0 14.2371 0.098772 14.4129 0.274588L19.7254 5.58709C19.9013 5.7629 20 6.00136 20 6.25V13.75C20 13.9986 19.9013 14.2371 19.7254 14.4129L14.4129 19.7254C14.2371 19.9013 13.9986 20 13.75 20H6.25C6.00136 20 5.7629 19.9013 5.58709 19.7254L0.274588 14.4129C0.098772 14.2371 0 13.9986 0 13.75V6.25C0 6.00136 0.098772 5.7629 0.274588 5.58709L5.58709 0.274588ZM6.63832 1.875L1.875 6.63832V13.3616L6.63832 18.125H13.3616L18.125 13.3616V6.63832L13.3616 1.875H6.63832ZM10 5C10.5178 5 10.9375 5.41974 10.9375 5.9375V10.3125C10.9375 10.8303 10.5178 11.25 10 11.25C9.48224 11.25 9.0625 10.8303 9.0625 10.3125V5.9375C9.0625 5.41974 9.48224 5 10 5ZM10 15C10.6904 15 11.25 14.4404 11.25 13.75C11.25 13.0596 10.6904 12.5 10 12.5C9.30965 12.5 8.75 13.0596 8.75 13.75C8.75 14.4404 9.30965 15 10 15Z",
    fill: "#9A6700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_505_40168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlwaysFailing);
export default __webpack_public_path__ + "static/media/always-failing.ad4a2f7d5eccb51768590416827c461d.svg";
export { ForwardRef as ReactComponent };